import type { ComponentProps } from 'react'
import { CONTENT_ATTRIBUTE } from '~/lib/content/links'

/** Links styled like `TextLink`'s default variant. */
const links = '[&_a]:font-semibold [&_a]:text-accent [&_a:hover]:underline'

/**
 * A line of content rendered from inline Markdown (`renderInline`): text with
 * links, bold and italics. Sits inside the caller's paragraph or list item.
 */
export function InlineHtml({
  html,
  className = '',
  ...props
}: Omit<ComponentProps<'span'>, 'dangerouslySetInnerHTML' | 'children'> & {
  html: string
}) {
  return (
    <span
      className={`${links} ${className}`}
      {...CONTENT_ATTRIBUTE}
      dangerouslySetInnerHTML={{ __html: html }}
      {...props}
    />
  )
}
